<template>
  <div class="pages">
    <div class="top">
      <a href="" v-for="(item, index) in footerList" :key="index">
        {{ item.text }}
      </a>
    </div>
    <div class="bottom">
      <span>京ICP备16017333号 京ICP证165673号</span>
      <span>京公网安备11010508956345号 ********有限公司 营业执照</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navFooter',
  data() {
    return {
      footerList: [
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        },
        {
          text: '其他网站'
        }
      ]
    };
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth < 1504) {
          that.screenWidth = 1504;
        } else {
          that.screenWidth = document.body.clientWidth;
        }
      })();
    };
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 浅蓝色科技风格变量
$blue-primary: #4fc3ff;
$blue-secondary: #80d4ff;
$blue-glow: rgba(79, 195, 255, 0.5);
$blue-light: rgba(79, 195, 255, 0.3);
$blue-dark: #0a1a2a;
$text-glow: 0 0 10px rgba(79, 195, 255, 0.5);

.pages {
  width: 100%;
  background: linear-gradient(90deg, #0a1a2a 0%, #1a3a5a 100%) !important;
  border-top: 2px solid $blue-primary;
  box-shadow: 0 -5px 25px $blue-glow, 5px 5px 30px 15px $blue-light inset;
  border-radius: 20px 20px 0 0;
  padding: 80px 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  // 添加科技感网格背景
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        linear-gradient(90deg, rgba(79, 195, 255, 0.03) 1px, transparent 1px),
        linear-gradient(0deg, rgba(79, 195, 255, 0.03) 1px, transparent 1px);
    background-size: 50px 50px;
    pointer-events: none;
  }

  // 添加光效
  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle at 30% 30%, rgba(79, 195, 255, 0.1) 0%, transparent 50%);
    animation: rotate 20s linear infinite;
    pointer-events: none;
  }

  @keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .top {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
    padding: 0 40px;

    a {
      width: 14.28%;
      font-size: 18px;
      color: #c0e4ff;
      text-align: center;
      margin-bottom: 50px;
      text-decoration: none;
      transition: all 0.3s ease;
      position: relative;
      padding: 10px 0;

      // 添加底部光效
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
        transition: width 0.3s ease;
      }

      &:hover {
        color: $blue-primary;
        text-shadow: $text-glow;
        transform: translateY(-2px);

        &::after {
          width: 50%;
        }
      }

      // 添加边框效果
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, $blue-primary, transparent);
        transition: width 0.3s ease;
        opacity: 0;
      }

      &:hover::before {
        width: 80%;
        opacity: 1;
      }
    }
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
    margin-top: 40px;
    padding-top: 40px;
    border-top: 1px solid rgba(79, 195, 255, 0.3);

    span {
      width: 50%;
      font-size: 16px;
      color: #c0e4ff;
      text-align: center;
      position: relative;
      padding: 10px 20px;

      // 添加数字高亮
      &:first-child {
        &::before {
          content: 'ICP';
          color: $blue-primary;
          font-weight: bold;
          margin-right: 5px;
          text-shadow: $text-glow;
        }
      }

      &:last-child {
        &::before {
          content: '公安备案';
          color: $blue-primary;
          font-weight: bold;
          margin-right: 5px;
          text-shadow: $text-glow;
        }
      }

      // 添加数字样式
      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
        opacity: 0.5;
        transition: all 0.3s ease;
      }

      &:hover::after {
        width: 100px;
        opacity: 1;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .top a {
      width: 20%;
      font-size: 16px;
    }

    .bottom span {
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .top a {
      width: 25%;
      font-size: 14px;
      margin-bottom: 30px;
    }

    .bottom {
      flex-direction: column;
      gap: 20px;

      span {
        width: 100%;
        font-size: 12px;
      }
    }
  }
}
</style>